// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listbox {
    padding:0;
}
.listbox-container{
    display:grid;
    grid-template-rows:auto 1fr;
    position:relative;
    overflow:auto;
}
.grow-container{
    height:auto;
}

.listbox-content{
    position:absolute;
    grid-row-start: 2;
    overflow:auto;
}
.grow-content{
    position:relative;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/listbox/listbox.control.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".listbox {\n    padding:0;\n}\n.listbox-container{\n    display:grid;\n    grid-template-rows:auto 1fr;\n    position:relative;\n    overflow:auto;\n}\n.grow-container{\n    height:auto;\n}\n\n.listbox-content{\n    position:absolute;\n    grid-row-start: 2;\n    overflow:auto;\n}\n.grow-content{\n    position:relative;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
